import { Component, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ViewMatchedEmployeesComponent } from '../view-matched-employees/view-matched-employees.component';
import { EmployeeBusinessService } from 'DBadgeEmployee-app/src/app/core/services/business.service';
import { UIComponentsModule } from '@ui-app/app.module';
import { ApiConfig } from '@employee-configs/api.config';

@Component({
  selector: 'employee-findemployee',
  standalone: true,
  imports: [CommonModule, UIComponentsModule],
  templateUrl: './findemployee.component.html',
  styleUrl: './findemployee.component.less'
})
export class FindemployeeComponent {

  imageUrl: string | ArrayBuffer | null = null;
  base64String: string | null = null;
  isImageUploaded: boolean = false;
  items: any[] = [];
  fileName: string = '';
  modalRef: BsModalRef;  
  constructor(private http: HttpClient, 
    private businessService: EmployeeBusinessService,
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef,
    private router: Router) {}

    convertImageToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
    // Ensure the file is present
    if (!file) {
      reject("No file selected");
      return;
    }

    const reader = new FileReader();

    // Event handler executed when the load event is fired (i.e., reading is complete)
    reader.onload = () => {
      // reader.result contains the base64 encoded string
      resolve(reader.result as string);
    };

    // Event handler executed if reading the file fails
    reader.onerror = (error) => {
      reject(error);
    };

    // Read the file as a data URL (base64 encoded string)
    reader.readAsDataURL(file);
  });
}

  uploadImage() {
    // upload image logic
    this.isImageUploaded = true;
    this.cdr.detectChanges();
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*'; // Accept images only
    input.onchange = () => {
      // Files array is available through input.files
      const file = input.files ? input.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target?.result; // Set the image URL for display
          document.getElementById('uploadedImage')!.setAttribute('src', this.imageUrl as string);
          document.getElementById('uploadedImage')!.style.display = 'block';
          this.convertImageToBase64(file).then(base64 => {
            console.log("Base64 Encoded Image:", base64);
            this.base64String = base64;
            this.fileName = file.name;
            // You can now use this base64 encoded image as needed
          }).catch(error => {
            console.error("Error converting image to base64:", error);
          });
        };
        reader.readAsDataURL(file); // Read the file as a data URL

      }
    };
    // Trigger the file input dialog
    input.click();
  }


  removeImage() {
    if(this.imageUrl!= null) {
      this.imageUrl = null; // Reset the image URL
      //Optionally, if you need to directly manipulate the DOM (not recommended)
      const imageElement = document.getElementById('uploadedImage');
      if (imageElement) {
        imageElement.setAttribute('src', '');
        imageElement.style.display = 'none';
      }
      this.isImageUploaded = false;
      this.businessService.toasterService.success('Image removed successfully');
      this.items = [];
    } else {
      this.businessService.toasterService.warning('No Image to remove');
    }

  }

  searchImage() {
    this.cdr.detectChanges();
        // Prepare FormData
         var searchReqObj = {
          photoBase64:  this.base64String.split(',')[1],
          fileName: this.fileName,
          requestedBy: sessionStorage.getItem('userEmail').split('@')[0],
          photoGuId: ""
         }

         const headers = new HttpHeaders({
          'Content-Type': 'application/json',
        });
        // // Adjust the URL to your backend endpoint
        //const uploadUrl = 'https://cognito.dbadge.deloitte.com/employee/api/photo/searchasync';
        //const uploadUrl = 'https://dcognito.dbadge.deloitte.com/employee/api/photo/search';
        const uploadUrl = ApiConfig.EmployeeSearch.searchEmployee;
        this.http.post(uploadUrl, searchReqObj , {headers:headers}).subscribe({
          next: (response) => 
            {
              // Handle the response as needed. We need to map it to the items array format.
              if(response != null && response != undefined && response != 0)  {
                //var raisedRequestsUrl = 'https://cognito.dbadge.deloitte.com/employee/api/photo/searchrequests?alias=' + sessionStorage.getItem('userEmail').split('@')[0]; 
                //var raisedRequestsUrl = 'https://dcognito.dbadge.deloitte.com/employee/api/photo/searchrequests?alias=' + sessionStorage.getItem('LoggedInUserId').split('@')[0];
                //var raisedRequestsUrl = 'https://localhost:5001/api/photo/searchrequests?alias=' + 'hsaimohanharsha';
                var raisedRequestsUrl = ApiConfig.EmployeeSearch.fetchMyRequests + sessionStorage.getItem('userEmail').split('@')[0];
                this.http.get(raisedRequestsUrl, {headers:headers}).subscribe(
                  (result:any[]) => {
                    if(result != null && result != undefined) {
                      this.items = result;
                    }
                  }, ()=> {}, ()=> {
                  }
                );
                  this.businessService.toasterService.success('Image uploaded successfully. Fetching all requests raised by you!');
              }
              else {
                this.businessService.toasterService.error('Upload failed. Fetching all requests raised by you!');
              }           
            },
          error: (error) => {console.error('Upload failed', error)},
          complete: () => {
          }
        });
  }


  openModal(item) {
    this.modalRef = this.modalService.show(ViewMatchedEmployeesComponent, {
      backdrop: 'static',
      initialState: {
        selectedItem: item,
    }});
  }

  refreshGrid() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    //var raisedRequestsUrl = 'https://cognito.dbadge.deloitte.com/employee/api/photo/searchrequests?alias=' + sessionStorage.getItem('userEmail').split('@')[0]; 
    //var raisedRequestsUrl = 'https://dcognito.dbadge.deloitte.com/employee/api/photo/searchrequests?alias=' + sessionStorage.getItem('LoggedInUserId').split('@')[0]; 
    //var raisedRequestsUrl = 'https://localhost:5001/api/photo/searchrequests?alias=' + 'hsaimohanharsha';
    var raisedRequestsUrl = ApiConfig.EmployeeSearch.fetchMyRequests + sessionStorage.getItem('userEmail').split('@')[0];
    this.http.get(raisedRequestsUrl, {headers:headers}).subscribe(
      (result:any[]) => {
        if(result != null && result != undefined) {
          this.items = result;
        }
        this.businessService.toasterService.success('Updated my requests successfully!');
      }, ()=> {}, ()=> {
      }
    );

  }
}
